import { Directive, ElementRef, Input } from '@angular/core';
import { isNil } from 'lodash';
import { ElementSize } from 'mbs-ui-kit/models';

@Directive({
  selector: '[straightPageContent]'
})
export class StraightPageContentDirective {
  @Input()
  public set headerSize(value: ElementSize) {
    !isNil(value?.height) && this.host.nativeElement.style.setProperty('padding-top', `${value.height}px`);
  }

  constructor(private host: ElementRef) {}
}
